import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { Tooltip, toggleClass, } from '@grapecity/wijmo';
import "./gridEvent.css"
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import UpdateRecordButton from "../input/UpdateRecordButton";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";

function TkWrappingStandardUnitPrice ( props ) {

    const id = "TkWrappingStandardUnitPrice"

    const table = "TkWrappingStandardUnitPrice"

    const view = "TkVwWrappingStandardUnitPrice"

    const [grid, setGrid] = useState();

    const [schema, setSchema] = useState();

    const [isEmpty, setIsEmpty] = useState();

    const [api, setApi] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {

        let tooltip = new Tooltip();

        if (grid) {
            grid.formatItem.addHandler((flex, element) => {
                if (element.panel === flex.cells) {
                    let item = flex.rows[element.row].dataItem
                    let binding = flex.columns[element.col].binding
                    let data = item.description ? item.description : null;
                    toggleClass(element.cell, 'wj-has-notes', binding === "description" && data !== null );
                    if(binding === "description" && data !== null) {
                        tooltip.setTooltip(element.cell, `<h1>${data}<h1>`);
                    }
                }
            });
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);


    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema(table);

            if ( mounted ) {
                setSchema(schema);
            }

        })();

        return ( () => {
            mounted = false;
        } );


    }, []);

    const onInitialized = (grid) => {

        grid.allowSorting = false;

        setGrid(grid);
    };

    const onApiInitialized = (api) => {

        setApi(api);

    };
    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    }
    
    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    return (
        <BasicCrudScreenType 
            id={id} 
            table={table} 
            view={view} 
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onLoadData={onLoadData}
            noExcel
            noDelete
            noCreate
            noEdit
            noPagination
            onAppendButtonInFrontOfSearch={
                () => (
                    <>
                        <BasicCrudScreenActionItemLayout>
                            <UpdateRecordButton
                                id={id}
                                schema={schema}
                                grid={grid}
                                refresh={api}
                                disabled={isEmpty}
                                onSuccess={onSuccess}
                            />

                        </BasicCrudScreenActionItemLayout>
                    </>
                )
            }
        />
    );

}

export default TkWrappingStandardUnitPrice;
